// @flow
import React from 'react';
import styled from 'styled-components';
import { Common } from 'utils/ExportCommon';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import ErrorFocus from 'components/shared/ErrorFocus';
import HomeApplicationActions from 'actions/HomeApplicationActions';
import HomeApplicationStore from 'stores/HomeApplicationStore';
import * as Yup from 'yup';
import { get } from 'lodash';

const CouponPaymentGeneralBox = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
`;

const CheckGreen = styled(Common.CheckGreenSVG)`
  height: 16.96px;
  width: 14.99px;
  float: left;
`;

const Description = styled.div`
  height: 30px;
  width: 300px;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
`;

const AplicatedCodeText = styled.div`
  height: 15px;
  width: 144px;
  color: #4a4a4a;
  font-size: 12px;
  line-height: 12px;
  width: 160px;
`;

const AplicatedCodeTextError = styled.div`
  color: red;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 10px;
`;

const JustPay = styled.div`
  height: 30px;
  width: 300px;
  background-color: #efeffa;
  margin-top: 60px;
  padding: 8px;
  margin-bottom: 30px;
`;

const StyledInput = styled(Field)`
  height: 35px;
  width: 100%;
  border: 1px solid #ececec;
  border-radius: 3px;
  background-color: #ffffff;
`;

const StyledInputWithButton = styled(StyledInput)`
  height: 35px;
  width: 200px;
  border: 1px solid #ececec;
  border-radius: 3px;
  background-color: #ffffff;
`;

const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const StyledValidatedInputWithButton = styled(StyledValidatedInput)`
  position: relative;
  float: left;
`;

const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
  position: absolute;
  top: 35px;
  font-size: 14px;
`;

const SubmitButtonInput = styled(RenterApp.SubmitButton)`
  height: 35px;
  width: 100px;
  margin-left: 0px;
  float: left;
  box-shadow: 0 0px 0px 0;
  border-radius: 0px;
  background-color: ${({ color }) => color} !important;
`;

const ErrorWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
`;

type PropsType = {
  visible: boolean,
  homeApp: any,
  handlePromoCode: () => void,
  color?: string
};

type StateType = {
  errorCode: any,
  succesCode: any,
  discountCoupon: string
};

export default class DiscountPaymentComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    color: '#278C7E'
  };

  constructor(props: PropsType) {
    super(props);
    this.state = {
      errorCode: null,
      succesCode: null,
      discountCoupon: ''
    };
  }

  submitData = (values: {}, { resetForm }: any): void => {
    if (values && values.discountCoupon) {
      this.setState({
        discountCoupon: values.discountCoupon
      });
      HomeApplicationActions.validateHomeApplicationPromoCode(
        values.discountCoupon,
        { home_application_id: this.props.homeApp.id },
        this.succesPromoCode,
        this.errorPromoCode
      );
    }
  };

  succesPromoCode = (): void => {
    this.setState({
      succesCode: HomeApplicationStore.getCodeValidate(),
      errorCode: null
    });
    this.handlePromoCode();
  };

  errorPromoCode = (): void => {
    this.setState({
      errorCode: HomeApplicationStore.getCodeValidateError(),
      succesCode: null,
      discountCoupon: ''
    });
    this.handlePromoCode();
  };

  validationSchema = () => {
    return Yup.object().shape({
      discountCoupon: Yup.string().required('Código requerido')
    });
  };

  defaultValues = (): {} => {
    return {
      discountCoupon: ''
    };
  };

  handlePromoCode = (): void => {
    this.props.handlePromoCode(
      this.state.discountCoupon,
      this.state.succesCode
    );
  };

  changeDataCode = (errors: any) => {
    if (get(errors, 'discountCoupon'))
      this.setState({
        discountCoupon: '',
        succesCode: ''
      });
  };

  renderDiscountPaymentForm = (formik: any): void => {
    const { errors, touched } = formik;
    const { color } = this.props;
    return (
      <Form>
        <StyledValidatedInputWithButton>
          <StyledInputWithButton
            type="text"
            name="discountCoupon"
            placeholder="Ingrésalo aquí"
            className={errors.name && touched.name ? 'has-error' : ''}
            onBlur={() => {
              this.changeDataCode(errors);
            }}
          />
          <StyledErrorMessage name="discountCoupon" component="div" />
        </StyledValidatedInputWithButton>
        <SubmitButtonInput color={color} type="submit">
          Enviar
        </SubmitButtonInput>

        {this.state.succesCode && !get(errors, 'discountCoupon') && (
          <div>
            <AplicatedCodeText>
              <CheckGreen />
            </AplicatedCodeText>
            <AplicatedCodeText>Código válido.</AplicatedCodeText>
            <JustPay>
              Se te hará un descuento de: $
              {this.state.succesCode.discount_in_amount}
            </JustPay>
          </div>
        )}

        {this.state.errorCode && !get(errors, 'discountCoupon') && (
          <ErrorWrapper>
            <AplicatedCodeTextError>
              {this.state.errorCode.error}
            </AplicatedCodeTextError>
          </ErrorWrapper>
        )}

        <ErrorFocus />
      </Form>
    );
  };

  render() {
    return (
      <CouponPaymentGeneralBox visible={this.props.visible}>
        <Description>¿Tienes un cupón de descuento?</Description>
        <Formik
          onSubmit={this.submitData}
          render={this.renderDiscountPaymentForm}
          validationSchema={this.validationSchema()}
          initialValues={this.defaultValues()}
        />
      </CouponPaymentGeneralBox>
    );
  }
}
